import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';

const genreLinks = [
  { label: '悬疑', type: 'movie' },
  { label: '科幻', type: 'movie' },
  { label: '爱情', type: 'movie' },
  { label: '武侠', type: 'tv' },
  { label: '年代', type: 'tv' },
  { label: '医疗', type: 'tv' },
];

const topics = [
  { title: '慢节奏治愈片单', desc: '适合周末夜晚安静看完的六部作品', icon: 'ri-moon-clear-line' },
  { title: '一晚上看完的悬疑短剧', desc: '八集以内，节奏紧凑不拖沓', icon: 'ri-time-line' },
  { title: '被低估的国产年代剧', desc: '在烟火气里看一场时代变迁', icon: 'ri-home-heart-line' },
];

interface Props {
  historyIds: string[];
}

export default function SidePanel({ historyIds }: Props) {
  const historyFilms = historyIds
    .map((id) => films.find((film) => film.id === id))
    .filter((film): film is NonNullable<typeof film> => Boolean(film))
    .slice(0, 4);

  return (
    <aside className="flex flex-col gap-4">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">快速分类</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {genreLinks.map((genre) => (
            <Link
              key={`${genre.type}-${genre.label}`}
              to={`/category/${genre.type}?genre=${encodeURIComponent(genre.label)}`}
              className="inline-flex items-center rounded-md bg-secondary-100 px-2.5 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer whitespace-nowrap"
            >
              {genre.label}
            </Link>
          ))}
        </div>
        <div className="mt-4 flex items-center gap-2 border-t border-background-200 pt-3.5">
          <Link
            to="/category/movie"
            className="flex flex-1 items-center justify-center gap-1 rounded-md border border-primary-200 bg-primary-50 py-2 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-film-line w-3.5 h-3.5 flex items-center justify-center" />
            全部电影
          </Link>
          <Link
            to="/category/tv"
            className="flex flex-1 items-center justify-center gap-1 rounded-md border border-primary-200 bg-primary-50 py-2 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-live-line w-3.5 h-3.5 flex items-center justify-center" />
            全部剧集
          </Link>
        </div>
      </div>

      <div className="rounded-lg bg-primary-900 p-4 text-background-100 md:p-5">
        <div className="flex items-center gap-2">
          <i className="ri-compass-3-line text-accent-300 w-4 h-4 flex items-center justify-center" />
          <h2 className="font-heading text-base font-bold text-background-50">专题导航</h2>
        </div>
        <ul className="mt-3 space-y-2.5">
          {topics.map((topic) => (
            <li key={topic.title}>
              <Link
                to="/category/movie"
                className="group flex items-start gap-2.5 rounded-md p-2 transition-colors hover:bg-primary-800 cursor-pointer"
              >
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-800 text-accent-300">
                  <i className={`${topic.icon} text-sm w-4 h-4 flex items-center justify-center`} />
                </span>
                <span className="min-w-0">
                  <span className="block text-[13px] font-medium text-background-50">{topic.title}</span>
                  <span className="mt-0.5 block text-[11px] leading-relaxed text-primary-200">
                    {topic.desc}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {historyFilms.length > 0 && (
        <div className="rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-5 anim-fade-in">
          <div className="flex items-center gap-2">
            <i className="ri-history-line text-foreground-500 w-4 h-4 flex items-center justify-center" />
            <h2 className="font-heading text-base font-bold text-foreground-950">浏览记录</h2>
          </div>
          <ul className="mt-3 space-y-2">
            {historyFilms.map((film) => (
              <li key={film.id}>
                <Link
                  to={`/detail/${film.id}`}
                  className="flex items-center gap-2.5 rounded-md p-1.5 transition-colors hover:bg-background-200/70 cursor-pointer"
                >
                  <span className="h-11 w-8 shrink-0 overflow-hidden rounded bg-background-200">
                    <img
                      src={film.poster}
                      alt={`${film.title}封面`}
                      title={`${film.title}剧情介绍 - 同学的妈妈`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-xs font-medium text-foreground-900">{film.title}</span>
                    <span className="mt-0.5 block font-label text-[10px] text-foreground-500">
                      {film.year} · {film.genres[0]}
                    </span>
                  </span>
                  <i className="ri-arrow-right-s-line text-foreground-400 w-3.5 h-3.5 flex items-center justify-center" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
}